module.exports = __webpack_public_path__ + "img/R-G.d902f567.png";